export function snackbarDuration(state = 5000, action) {
  switch (action.type) {
    case 'OPEN_SNACKBAR':
      return typeof action.duration === 'undefined' ? state : action.duration;
    case 'CLOSE_SNACKBAR':
      return 5000;
    default:
      return state;
  }
}
